import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#111827', // Charcoal primary
    },
    secondary: {
      main: '#6B7280', // Gray secondary
    },
    accent: {
      main: '#F59E0B', // Sunlight accent
    },
    background: {
      default: '#ffffff', // Clean white background
      paper: '#f8fafc',   // Slightly off-white for cards
    },
    text: {
      primary: '#ffffff',
      secondary: '#a1a1aa',
    },
    divider: 'rgba(255, 255, 255, 0.05)',
  },
  typography: {
    fontFamily: "'Inter', 'Plus Jakarta Sans', sans-serif",
    h1: {
      fontWeight: 800,
      fontSize: '5rem',
      lineHeight: 1.05,
      letterSpacing: '-0.05em',
      '@media (min-width:600px)': { fontSize: '6rem' },
      '@media (min-width:960px)': { fontSize: '7.5rem' },
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.2,
      letterSpacing: '-0.03em',
      '@media (min-width:600px)': { fontSize: '2.5rem' },
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    button: {
      textTransform: 'none',
      letterSpacing: '0.01em',
    },
    body1: {
      letterSpacing: '-0.01em',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#030303',
          backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(139, 92, 246, 0.03), transparent 50%)',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(3, 3, 3, 0.6)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '0.6rem 1.5rem',
          fontWeight: 600,
          transition: 'all 0.2s ease-in-out',
        },
        containedPrimary: {
          background: '#ffffff',
          color: '#000000',
          '&:hover': {
            background: '#e4e4e7',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(255,255,255,0.1)',
          },
        },
        outlined: {
          border: '1px solid rgba(255,255,255,0.1)',
          color: '#ffffff',
          '&:hover': {
            borderColor: 'rgba(255,255,255,0.3)',
            backgroundColor: 'rgba(255,255,255,0.02)',
            transform: 'translateY(-1px)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(10, 10, 10, 0.6)',
          backdropFilter: 'blur(20px)',
          borderRadius: 16,
          border: '1px solid rgba(255,255,255,0.05)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.05)',
          color: '#e4e4e7',
        },
      },
    },
  },
});

export default theme;
